const setXmlLoad = (xmlLoadObj) => {
  return {
    type: "SET_XML_LOAD",
    payload: xmlLoadObj
  }
}

export default { setXmlLoad }
